import { render, staticRenderFns } from "./BranchInventory.vue?vue&type=template&id=5091511f&scoped=true&"
import script from "./BranchInventory.vue?vue&type=script&lang=js&"
export * from "./BranchInventory.vue?vue&type=script&lang=js&"
import style0 from "./BranchInventory.vue?vue&type=style&index=0&id=5091511f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5091511f",
  null
  
)

export default component.exports